import request from '@/utils/request'

import { Collector, Field, WorkerResult } from '@/types/collector.d.ts'

const baseUrl = '/collector'

// -----------------------------------------------------------------------------------------------------------------
// Collector
// -----------------------------------------------------------------------------------------------------------------

/** Create collector */
export function Create(c: Collector): Promise<Collector> {
  return request.post(baseUrl, c)
}

/** Find collector */
export function Find(q?: Collector): Promise<Collector[]> {
  return request.get(baseUrl, { headers: { query: q } })
}

/** Get collector by specified id */
export function Get(id: number): Promise<Collector> {
  return request.get(`${baseUrl}/${id}`)
}

/** Patch collector */
export function Patch(id: number, c: Collector): Promise<Collector> {
  return request.patch(`${baseUrl}/${id}`, c)
}

/** Delete collector with specified id */
export function Delete(id: number): Promise<Collector> {
  return request.delete(`${baseUrl}/${id}`)
}

// -----------------------------------------------------------------------------------------------------------------
// Collector control
// -----------------------------------------------------------------------------------------------------------------

/** Test connection */
export function TestConnection(id: number): Promise<WorkerResult> {
  return request.put(`${baseUrl}/${id}/test`)
}

// -----------------------------------------------------------------------------------------------------------------
// Field
// -----------------------------------------------------------------------------------------------------------------

export function CreateField(f: Field): Promise<Field> {
  return request.post(`${baseUrl}/field`, f)
}

export function ImportFields(collectorId: number, f: Field[]): Promise<Field> {
  return request.post(`${baseUrl}/${collectorId}/import`, f)
}

export function FindField(q?: Field): Promise<Field[]> {
  return request.get(`${baseUrl}/field`, { params: q })
}

export function GetField(id: number): Promise<Field> {
  return request.get(`${baseUrl}/field/${id}`)
}

export function PatchField(id: number, f: Field): Promise<Field> {
  return request.patch(`${baseUrl}/field/${id}`, f)
}

export function DeleteField(id: number): Promise<Field> {
  return request.delete(`${baseUrl}/field/${id}`)
}

// -----------------------------------------------------------------------------------------------------------------
// Collections
// -----------------------------------------------------------------------------------------------------------------

interface LastRecord {
  // eslint-disable-next-line
  [key: string]: any
}

interface LastRecords {
  [key: string]: LastRecord
}

export function GetLastRecord(ids: string[] | number[]): Promise<LastRecords> {
  return request.get(`${baseUrl}/collection/last?id=${ids.join(',')}`)
}
